<template>
	<div class="content">
		<van-nav-bar
		  title="个人中心"
		 
		  left-arrow
		  
		/>
		<van-row class="text">
		  <van-col span="12" class='img'>头像</van-col>
		 
		  <van-col span="12" class='img'>
		  <img class='wx_img' src="../../../../static/mj.jpg">
		  </van-col>
		  
		  <van-col span="12" class='text_'>微信名称</van-col>
		  <van-col span="12" class='text_'>似曾相识</van-col>
		  <van-col span="12" class='text_'>地区</van-col>
		  <van-col span="12" class='text_'>广州深圳</van-col>
		  <van-col span="12" class='text_'>地区</van-col>
		  <van-col span="12" class='text_'>广州深圳</van-col>
		  <van-col span="12" class='text_'>地区</van-col>
		  <van-col span="12" class='text_'>广州深圳</van-col>
		</van-row>
		
		
		<van-tabbar v-model="active">
		   <van-tabbar-item icon="home-o"><router-link to="/wx_index" class="router" >我的预约</router-link></van-tabbar-item>
		   <van-tabbar-item icon="search"><router-link to="/wx_visit" class="router">我的访问</router-link></van-tabbar-item>
		   <van-tabbar-item icon="setting-o"><router-link to="/wx_center" class="router activerouter">个人中心</router-link></van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
	
  export default {
  data () {
    return {
      foo: 'bar',
	      active: 2,
		  tel: '',
	      text: '',
	      digit: '',
	      number: ''
	   
	    }
    },
	methods: { }
  
}
</script>

<style>
	
	.content{
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
	}

	.img {
		border-top: 1px solid gainsboro;
		border-bottom: 1px solid gainsboro;
		height: 60px;
		line-height: 60px;
		padding-left: 16px;
	}
	.wx_img{
		width: 58px;
		height: 58px;
		background-size: cover;
		
	}
	.text_{
		height: 40px;
		border-bottom: 1px solid gainsboro;
		line-height: 40px;
		padding-left: 16px;
	}
	.text{
		font-size: 14px;
		text-align: left;
	}
</style>


// WEBPACK FOOTER //
// src/system/index/wechatvisitors/wx_center.vue